import React from 'react';
import { Select, InputLabel, FormControl, FormHelperText, MenuItem } from "@mui/material";
import './MultipleSelectComponent.css';

export default function MultipleSelectComponent(props) {

    // Info
    const id = props.id;
    const input = props.handler.form[id];
    const label = input.label;

    const [error, setError] = React.useState(input.error);
    const [isFocus, setFocus] = React.useState(false);

    // Value
    const [value, setValue] = React.useState([]);
    React.useEffect(() => {
        if (input.value !== undefined) {
            setValue((previous) => (input.value !== previous ? input.value : previous));
        }
    }, [input.value]);
    React.useEffect(() => {
        setError((previous) => (previous !== input.error ? input.error : previous));
    }, [input.error]);

    // On
    const onChange = (event) => {
        let newValue = event.target.value ?? [];
        setValue(newValue);

        if (props.onChange) props.onChange(newValue);
    }
    const onBlur = () => {
        setFocus(false);
        props.handler.setValue(id, value);
        let error = props.handler.getErrorByField(input);
        setError(error);
        props.handler.setError(id, error);
    }
    const onFocus = () => {
        setFocus(true);
    }

    return (
        <div className="content-multi-select">
            <FormControl
                variant="outlined"
                className={`multipleSelect ${
                    isFocus
                        ? 'multipleSelectFocus'
                        : error
                            ? 'multipleSelectError'
                            : (value && value.length > 0) && !input.disabled
                                ? 'multipleSelectValid'
                                : ''
                }`}
            >
                <InputLabel htmlFor="outlined">
                    {label + ((input.options && input.options.validation && input.options.validation.indexOf('required') > -1) ? ' *' : '')}
                </InputLabel>
                <Select
                    labelId={input.name}
                    multiple={true}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    onFocus={onFocus}
                    autoFocus={false}
                    inputProps={{
                        name: label + ((input.options && input.options.validation && input.options.validation.indexOf('required') > -1) ? ' *' : '')
                    }}
                    MenuProps={{
                        anchorOrigin: { vertical: "bottom", horizontal: "left" },
                        className: 'menu'
                    }}
                    label={label + ((input.options && input.options.validation && input.options.validation.indexOf('required') > -1) ? ' *' : '')}
                    disabled={input.disabled}
                >
                    {
                        props.options.map(data => (
                            <MenuItem key={data.value} value={data.value}>
                                {data.label}
                            </MenuItem>
                        ))
                    }
                </Select>
                <FormHelperText>{error && !isFocus ? error : input.textHelper}</FormHelperText>
            </FormControl>
        </div>
    );
}
